"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var regexInvalidEntity = exports.regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;